var _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _circle5, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 24,
    viewBox: "0 0 168 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#0070C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 12,
    r: 11.5,
    stroke: "#0070C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 12C60 10.4241 59.6896 8.86371 59.0866 7.4078C58.4835 5.95189 57.5996 4.62902 56.4853 3.51472C55.371 2.40042 54.0481 1.5165 52.5922 0.913445C51.1363 0.310389 49.5759 -6.88831e-08 48 0L48 12H60Z",
    fill: "#0070C0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 12,
    r: 11.5,
    stroke: "#0070C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24C87.1826 24 90.2348 22.7357 92.4853 20.4853C94.7357 18.2348 96 15.1826 96 12C96 8.8174 94.7357 5.76516 92.4853 3.51472C90.2348 1.26428 87.1826 6.19675e-07 84 0L84 12L84 24Z",
    fill: "#0070C0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 12,
    r: 11.5,
    stroke: "#0070C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 12C108 14.3734 108.704 16.6935 110.022 18.6668C111.341 20.6402 113.215 22.1783 115.408 23.0866C117.601 23.9948 120.013 24.2324 122.341 23.7694C124.669 23.3064 126.807 22.1635 128.485 20.4853C130.164 18.8071 131.306 16.6689 131.769 14.3411C132.232 12.0133 131.995 9.60051 131.087 7.4078C130.178 5.21509 128.64 3.34094 126.667 2.02237C124.693 0.703788 122.373 1.79185e-07 120 0L120 12L108 12Z",
    fill: "#0070C0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 12,
    r: 11.5,
    stroke: "#0070C0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 12,
    r: 12,
    fill: "#0070C0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/PieChartIcon.3fe46b4590e0e0abcfab72117aa59a7c.svg";
export { ForwardRef as ReactComponent };